import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WatchDndTargetsService {
    $doc: any = $(document);

    constructor() {
        $(document).on("keyup", this.HandlerUp);
        $(document).on("keydown", this.HandlerDown);
    }

    CleanUpService() {
        $(document).off("keyup", this.HandlerUp);
        $(document).off("keydown", this.HandlerDown);
    }

    HandlerUp(e) {
        //KeyPressed='d'
        if (e.keyCode === 68) {
            //service.DKeyPressed = false;
        }
    }

    HandlerDown(e) {
        //KeyPressed='d'
        if (e.keyCode === 68) {
            //service.DKeyPressed = true;
        }
    }
}
